import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const getNoCache = () => String(new Date().getTime());

export const toRequest = <Type = any>(
  requestMethod:
    | typeof axios.get
    | typeof axios.post
    | typeof axios.put
    | typeof axios.delete,
  requestMethodOnlineParams:
    | [string]
    | [string, AxiosRequestConfig | any]
    | [string, any, AxiosRequestConfig],
  offlineJSONName?: string
): Promise<AxiosResponse<Type>> => {
  if (window.env.isOffline) {
    const url = `/registro/assets/mock/${offlineJSONName}.json`;
    return axios.get(url);
  } else {
    return requestMethod.apply({}, requestMethodOnlineParams as any) as Promise<
      AxiosResponse<Type>
    >;
  }
};
